import {Injectable} from '@angular/core';


Injectable({
  providedIn: 'root'
})

@Injectable()
export class SuggestedAddressService {
  constructor() {}

  public isCloseButtonActivated: boolean = false;
}


